<template>
	<div class="mian-shouye">
		<div class="shouye-img">
			<div class="mian-shouye-img">
			<a-carousel autoplay>
				<img
				v-for="item in filterData"
				:key="item.id"
				:src="item.smallImage"
				style="width: 100%;height: 515px;">
			</a-carousel>
			</div>
		</div>
		<div class="biaoti">
			<span class="mian-biaoti">信息公开</span>
		</div>
		<div class="shouye-firstmessage">
			<div class="mian-shouye-message">
				<div class="shouye-message">
					<div class="shouye-message-tu">
						<img src="../assets/img/xiangmuall.png" alt="" />
						<span>2022年项目总数(个)</span>
					</div>
					<span class="shouye-message-span">{{ messagelist.project_num }}</span>
				</div>
				<div class="shouye-message">
					<div class="shouye-message-tu">
						<img src="../assets/img/jjingzshu.png" alt="" />
						<span>2022年基金总数(个)</span>
					</div>
					<span class="shouye-message-span">{{ messagelist.fund_num }}</span>
				</div>
				<div class="shouye-message">
					<div class="shouye-message-tu">
						<img src="../assets/img/histroyall.png" alt="" />
						<span>历史捐款总额(元)</span>
					</div>
					<span class="shouye-message-span">{{ messagelist.history_all }}</span>
				</div>
				<div class="shouye-message">
					<div class="shouye-message-tu">
						<img src="../assets/img/histroyall.png" alt="" />
						<span>{{ messagelist.year }}年捐款总额(元)</span>
					</div>
					<span class="shouye-message-span">{{ messagelist.year_all }}</span>
				</div>
			</div>
		</div>
		<div class="juankuangdiv">
			<div class="juankuang">
				<div class="juankuangjuankuang">
					<div class="juankuang-left">
						<div class="juankuang-left-one">
							<img src="../assets/img/hoszhi.png" alt="" />
							<span>捐款详细</span>
						</div>
						<div class="juankuang-left-two">
							<tableAutoScroll></tableAutoScroll>
						</div>
					</div>
					<div class="juankuang-right">
						<div class="juankuang-right-one">
							<div class="juankuang-left-one">
								<img src="../assets/img/hoszhi.png" alt="" />
								<span>捐款公示</span>
							</div>
							<div class="juankuang-right-one-flex">
								<div class="juankuang-right-one-flex-one">
									<router-link :to="{name:'infoOpen', query:{jumpIndex: 1,jumpChildIndex: 0}}">
										<div class="juankuang-right-one-flex-one1">
											<div class="flex-div">
												<img src="../assets/img/juankuangong.png" alt="" />
												<div class="span-div">
													<span>捐款</span>
													<span>公示</span>
												</div>
											</div>
										</div>
									</router-link>
									
									<router-link :to="{name:'infoOpen', query:{jumpIndex: 1,jumpChildIndex: 1}}">
										<div class="juankuang-right-one-flex-one2">
											<div class="flex-div">
												<img src="../assets/img/juanwu.png" alt="" />
												<div class="span-div">
													<span>捐物</span>
													<span>公示</span>
												</div>
											</div>
										</div>
									</router-link>
									<router-link :to="{name:'infoOpen', query:{jumpIndex: 1,jumpChildIndex: 2}}">
										<div class="juankuang-right-one-flex-one3">
											<div class="flex-div">
												<img src="../assets/img/xiangmugong.png" alt=""/>
												<div class="span-div">
													<span>项目</span>
													<span>公示</span>
												</div>
											</div>
										</div>
									</router-link>
								</div>
								
								<div class="juankuang-right-one-flex-one">
									<router-link :to="{name:'infoOpen', query:{jumpIndex: 1,jumpChildIndex: 3}}">
										<div class="juankuang-right-one-flex-one2">
											<div class="flex-div">
												<img src="../assets/img/yusuan.png" alt="" />
												<div class="span-div">
													<span>预决算</span>
													<span>公示</span>
												</div>
											</div>
										</div>
									</router-link>
									<router-link :to="{name:'infoOpen', query:{jumpIndex: 1,jumpChildIndex: 4}}">
										<div class="juankuang-right-one-flex-one1">
											<div class="flex-div">
												<img src="../assets/img/gongshi.png" alt="" />
												<div class="span-div">
													<span>审计报</span>
													<span>告公示</span>
												</div>
											</div>
										</div>
									</router-link>
									<router-link :to="{name:'infoOpen', query:{jumpIndex: 1,jumpChildIndex: 0}}">
										<div class="juankuang-right-one-flex-one4">
											<span>[查看更多]</span>
										</div>
									</router-link>
								</div>
							</div>
						</div>
						<div class="juankuang-right-two">
							<div class="juankuang-left-one">
								<img src="../assets/img/hoszhi.png" alt="" />
								<span>捐款通道</span>
							</div>
							<div class="juankuang-right-two-img">
								<router-link :to="{name:'channel'}">
									<img src="../assets/img/juankuai.png" alt="" />
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="zhuangshi">
			<img src="../assets/img/zhuangshi.png" alt="" />
		</div>
		<div class="biaoti">
			<span class="mian-biaoti">工作动态</span>
		</div>
		<div class="dongtaidiv1">
			<div class="dongtai">
				<div class="dongtai-img" v-for="(item, index) in Dynamicwork" :key="index">
					<router-link :to="{name:'workDetail', query:{id:item.id}}">
						<img :src="item.smallImage" alt="" />
						<div class="dongtai-img-heard">
							<div class="dongtai-img-footer">
								<span class="dongtai-imgdiv">{{ item.title }}</span>
								<span class="dongtai-imgdiv2">{{ item.publishDate }}</span>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
		<div class="dongtaidiv2">
				<div class="zuixin">
					<div class="zuixin-left" style="position: relative;" @click="$jumpTo('/workDetail',{id:imgLeftList.id,type:'zx'})">
						<img :src="imgLeftList.smallImage" alt="" />
						<div class="img-title">
							<div class="ball-box">
								<div class="ball" style="background-color: #FFFFFF;"></div>
							</div>
							<span>{{imgLeftList.title}}</span>
						</div>
					</div>
					<div class="zuixin-right" style="padding: 0 10px;background-color: #FFFFFF;overflow: hidden;">
						<div class="tab-box">
							<div class="tab-item" style="border-right: 2px solid #E60011;justify-content: flex-start;" @click="changeMsgNew" :class="highLiang==0?'activeMsg':''">
								<img :src="img1ColorChange" alt="">最新信息
							</div>
							<div class="tab-item" style="justify-content: flex-end;" @click="changeMsgReport" :class="highLiang==1?'activeMsg':''">
								<img :src="img2ColorChange" alt="">媒体报道
							</div>
						</div>
						<div v-if="highLiang==0">
							<div style="width: 100%;max-height: 320px;overflow: hidden;">
								<div v-for="(item,index) in newMsgList" style="display: flex;" @click="$jumpTo('/workDetail',{id:item.id,type:'zx'})">
									<div class="ball-box">
										<div class="ball"></div>
									</div>
									<!-- 用li标签不行 -->
									<div class="li-msg">
										<span class="span">{{item.title}}</span>
										<span>》</span>
									</div>
								</div>
							</div>
							<div class="look-more">
								<span @click="$jumpTo('/workList',{type:'zx'})">[查看更多]</span>
							</div>
						</div>
						<div v-if="highLiang==1">
							<div style="width: 100%;max-height: 320px;overflow: hidden;">
								<div v-for="(item,index) in reportMsgList" style="display: flex;">
									<div class="ball-box">
										<div class="ball"></div>
									</div>
									<!-- 用li标签不行 -->
									<div class="li-msg" @click="jumpLink(item.link)">
										<span class="span">{{item.title}}</span>
										<span>》</span>
									</div>
								</div>
							</div>
							<div class="look-more">
								<span @click="$jumpTo('/workList',{type:'mt'})">[查看更多]</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		<div class="hoqibeijing">
			<img class="hqclassimgbtm" src="../assets/img/hqbottom.png" alt="">
			<div class="biaoti">
				<span class="mian-biaoti">党建工作</span>
			</div>
			<div class="hqdangjian">
				<div class="dongtai">
					<div class="hqdangjian-img" v-for="(item, index) in ConstructionWork" :key="index">
						<a :href=item.linkadd target="_blank">
							<img :src="item.smallImage" alt="" />
						</a>
					</div>
				</div>
			</div>
			<div class="dongtaidiv2">
				<div class="zuixin">
					<div class="zuixin-left" style="position: relative;" @click="$jumpTo('/workDetail2',{id:ConstructionWorkData.id,type:'zx'})">
						<img :src="ConstructionWorkData.smallImage" alt="" />
						<div class="img-title">
							<div class="ball-box">
								<div class="ball" style="background-color: #FFFFFF;"></div>
							</div>
							<span>{{ConstructionWorkData.title}}</span>
						</div>
					</div>
					<div class="zuixin-right" style="padding: 0 10px;background-color: #FFFFFF;overflow: hidden;">
						<div style="width: 100%;max-height: 320px;overflow: hidden;">
							<div v-for="(item,index) in newMsgListData" style="display: flex;" @click="$jumpTo('/workDetail2',{id:item.id,type:'zx'})">
								<div class="ball-box">
									<div class="ball"></div>
								</div>
								<!-- 用li标签不行 -->
								<div class="li-msg">
									<span class="span">{{item.title}}</span>
									<span>》</span>
								</div>
							</div>
						</div>
						<div class="look-more">
							<span @click="$jumpTo('/workList',{type:'zx'})">[查看更多]</span>
						</div>
					</div>
				</div>
			</div>

			<div class="biaoti"><span class="mian-biaoti">项目与基金</span></div>
			<canvasTu></canvasTu>
			<div class="biaoti"><span class="mian-biaoti">友情链接</span></div>
			<div class="friend-div">
				<div class="friend-img">
					<div class="friend-img-div" v-for="(item, index) in Friendly" :key="index">
						<a :href=item.org_link target="_blank">
							<img :src="item.org_img" alt="" />
							<span>{{ item.org_name }}</span>
						</a>
					</div>
					
				</div>
				<div class="zuixin-right-two-twoaaa">
					<router-link :to="{name:'partner', query:{}}">
					<span class="zuixin-right-two-twoaaaz">[查看更多]</span>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import apiUrls from '@api';
import tableAutoScroll from "../components/tableAutoScroll.vue"
import zuimeassage from '../components/zuimeassage';
import CanvasTu from '../components/canvasTu.vue';
const columns = [
	{
		title: '姓名',
		dataIndex: 'name',
		key: 'name'
	},
	{
		title: '时间',
		dataIndex: 'date',
		key: 'date'
	},
	{
		title: '金额(元)',
		dataIndex: 'money',
		key: 'money'
	},
	{
		title: '捐赠方式',
		key: 'type',
		dataIndex: 'type'
	},
	{
		title: '捐赠类别',
		key: 'category',
		dataIndex: 'category'
	},
	{
		title: '备注',
		key: 'note',
		dataIndex: 'note'
	}
];

export default {
	components: {
		tableAutoScroll,
		zuimeassage,
		CanvasTu
	},
	props: {
    node: {
      type: String,
      default: function () {
        return "sylbt";
      },
    },
    //哪个菜单栏目
    type: {
      type: String,
      default: function () {
        return "home";
      },
    },
  },
	data() {
		return {
			flag: false,
      		caData: [],
			filterData:[],
			//控制最新信息和媒体报道的显示以及tab栏的高亮
			highLiang: 0,
			img1ColorChange:  require('../assets/img/hoszhi00.png'),
			img2ColorChange:  require('../assets/img/hoszhi00.png'),
			newMsgList: [],
			newMsgListData:[],
			reportMsgList: [],
			imgLeftList: {},
			ConstructionWorkData:{},
			messagetable: [],
			columns,
			messagelist: {},
			Dynamicwork: [],
			ConstructionWork:[],
			Friendly: [],
		};
	},
	computed: {},
	created() {
		this.getData();
		this.getMessage(), 
		this.getTable(),
		this.getDynamicwork(),
		this.getFriendly(),
		this.getConstructionWork(),
		this.getConstructionWorkData();
	},
	mounted() {
		//获取工作动态数据
		this.getNewMsgData()
		this.getReportMsgData()
	},
	methods: {
		jumpLink(url) {
			window.open(url, "_blank");
		},
		// 获取轮播详情
		getData() {
			apiUrls.getList({ node: this.node, page: 0, size: 3 }).then((res) => {
				this.caData = res.results.data;
				this.filterData = this.caData.filter(item=>item.smallImage)
			});
		},
		//最新信息和媒体报道
		changeMsgNew() {
			this.highLiang = 0
			this.imgLeftList = this.newMsgList[0]
			this.img1ColorChange = require('../assets/img/hoszhi.png')
			this.img2ColorChange = require('../assets/img/hoszhi00.png')
		},
		changeMsgReport() {
			this.highLiang = 1
			this.imgLeftList = this.reportMsgList[0]
			this.img2ColorChange = require('../assets/img/hoszhi.png')
			this.img1ColorChange = require('../assets/img/hoszhi00.png')
		},
		//最新信息
		getNewMsgData() {
			this.img1ColorChange = require('../assets/img/hoszhi.png')
			apiUrls.getList({ node: 'gzdt_zxzx' }).then(res => {
				this.newMsgList = res.results.data
				this.imgLeftList = this.newMsgList[0]
				// console.log(this.newMsgList)
			});
		},
		//媒体报道
		getReportMsgData() {
			apiUrls.getList({ node: 'gzdt_mtbd' }).then(res => {
				// console.log(res.results.data)
				this.reportMsgList = res.results.data
				// console.log(this.reportMsgList)
			});
		},
		
		callback(key) {
			console.log(key);
		},
		getMessage() {
			apiUrls.getNode({ node: 'syxxgk' }).then(res => {
				this.messagelist = res.results.data;
			});
		},
		//捐款详情表
		getTable() {
			apiUrls.getList({ node: 'jkxx' }).then(res => {
				this.messagetable = res.results.data;
			});
		},
		//工作动态
		getDynamicwork() {
			apiUrls.getList({ node: 'sygzdt' }).then(res => {
				// console.log(res.results.data)
				this.Dynamicwork = res.results.data.splice(0,3);
			});
		},
		//党建工作
		getConstructionWork() {
			apiUrls.getList({ node: 'sydjlink' }).then(res => {
				// console.log(res)
				this.ConstructionWork = res.results.data;
			});
		},
		//党建
		getConstructionWorkData() {
			apiUrls.getList({ node: 'djgzdj', page: 0, size: 10 }).then(res => {
				this.newMsgListData = res.results.data
				// if(this.highLiang == 0)
				this.ConstructionWorkData = this.newMsgListData[0]
			});
		},
		//友情连接
		getFriendly() {
			apiUrls.getList({ node: 'yqlj' }).then(res => {
				this.Friendly = res.results.data;
			});
		},
		//跳转新页面
		// hrefto(item){
		// 	window.location.href= 'http://'+ item.org_link
		// 	console.log(item);
		// }
	}
};
</script>

<style lang="less">
.img-title {
	width: 100%;
	height: 43px;
	background-color: rgba(46, 46, 46, 0.76);
	position: absolute;
	bottom: 0;
	color: #FFFFFF;
	font-size: 16px;
	display: flex;
	align-items: center;
}
.shouye-img {
  display: flex;
  justify-content: center;
}
.mian-shouye-img {
  width: 1200px;
  height: 505px;
  /deep/ .ant-carousel {
    width: 100%;
    height: 100%;
    img {
      width: 1200px;
      height: 505px;
    }
  }
}
.tab-box {
	padding-left: 5px;
	height: 40px;
	width: 100%;
	font-size: 16px;
	font-family: "microsoft yahei";
	color: #777777;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	.tab-item {
		width: 110px;
		height: 20px;
		display: flex;
		align-items: center;
		cursor: pointer;
		img {
			margin-right: 5px;
			height: 15px;
			width: 15px;
		}
	}
	.activeMsg {
		color: #C11818;
	}
}	
.ball-box {
	width: 20px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	.ball {
		width: 5px;
		height: 5px;
		background-color: #000000;
		border-radius: 50%;
	}
}
.li-msg {
	cursor: pointer;
	width: 100%;
	height: 20px;
	color: #333333;
	margin-bottom: 20px;
	font-size: 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.span {
		width: 400px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
.look-more{
	width: 100%;
	height: 100%;
	text-align: right;
	color: #C11818;
	padding-right: 5px;
	span {
		cursor: pointer;
	}
}
	
	
.mian-shouye {
	height: 100%;
}
.zhuangshi {
	padding: 0 8.3%;
	width: 100%;
	margin: 0 auto;
}
.zhuangshi img {
	width: 100%;
	height: 43px;
}
.biaoti {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2% 0;
}
.mian-biaoti {
	display: flex;
	align-items: center;
	font-size: 24px;
	font-family: MicrosoftYaHeiUI;
	color: #333333;
	line-height: 30px;
}
.mian-biaoti::before {
	display: inline-block;
	content: '';
	width: 2px;
	height: 21px;
	background: #d0021b;
	border-radius: 1px;
	margin-right: 10px;
}
.mian-biaoti::after {
	display: inline-block;
	content: '';
	width: 2px;
	height: 21px;
	background: #d0021b;
	border-radius: 1px;
	margin-left: 10px;
}
.shouye-firstmessage {
	display: flex;
	justify-content: center;
}
.mian-shouye-message {
	width: 1200px;
	height: 132px;
	display: flex;
	justify-content: space-around;
}
.shouye-message {
	width: 283px;
	height: 132px;
	background: linear-gradient(180deg, rgba(250, 247, 247, 0) 0%, #f4ecec 100%);
	// display: flex;
	// flex-wrap: wrap;
}
.shouye-message-tu img {
	width: 45px;
	height: 45px;
}
.shouye-message-tu span {
	width: 69px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #c11818;
	line-height: 20px;
}
.shouye-message-span {
	width: 155px;
	height: 60px;
	font-size: 50px;
	font-family: 'YJSZ';
	color: #b60303;
	line-height: 60px;
}
.ant-table-thead tr th {
	background-color: #b60303 !important;
	color: white !important;
	height: 32px !important;
}
.juankuangdiv {
	display: flex;
	justify-content: center;
}
.juankuang {
	margin: 2% 0;
	padding: 0 8.3%;
	width: 100%;
	height: 574px;
	background: #f7f7f7;
	box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.17);
	display: flex;
	justify-content: center;
	align-items: center;
}
.juankuangjuankuang {
	display: flex;
	justify-content: space-between;
}
.juankuang-left {
	width: 782px;
	height: 501px;
	background: #ffffff;
}
.juankuang-right {
	margin-left: 2%;
	width: 390px;
	height: 501px;
	display: flex;
	flex-wrap: wrap;
}
.juankuang-right-one {
	width: 390px;
	height: 290px;
	background: #ffffff;
}
.juankuang-right-two {
	margin-top: 6%;
	width: 390px;
	height: 187px;
	background: #ffffff;
}
.juankuang-left-one {
	padding: 2% 0;
	display: flex;
	justify-content: center;
	align-items: center;
}
.juankuang-left-one img {
	width: 15px;
	height: 15px;
	margin-right: 5px;
}
.juankuang-left-one span {
	width: 77px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #c11818;
	line-height: 20px;
}
.juankuang-left-two {
	margin: 1% 3%;
}
.ant-table-pagination.ant-pagination {
	display: none;
}
.juankuang-right-one-flex {
	padding: 1% 1%;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
}
.juankuang-right-one-flex-one {
	margin: 1% 1%;
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.juankuang-right-one-flex-one1 {
	width: 110px;
	height: 88px;
	background: #df9161;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.flex-div {
	display: flex;
	justify-content: space-between;
}
.flex-div img {
	width: 32px;
	height: 32px;
}
.span-div {
	display: flex;
	flex-wrap: wrap;
	width: 50px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #bf7345;
	line-height: 18px;
}
.span-div span {
	width: 50px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
	font-weight: bold;
	color: #ffffff;
	line-height: 18px;
}
.juankuang-right-one-flex-one2 {
	width: 110px;
	height: 88px;
	background: #df6161;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.juankuang-right-one-flex-one3 {
	width: 110px;
	height: 88px;
	background: #df9161;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.juankuang-right-one-flex-one4 {
	width: 110px;
	height: 88px;
	background: #eaeaea;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.juankuang-right-one-flex-one4 span {
	width: 70px;
	height: 18px;
	font-size: 14px;
	font-family: MicrosoftYaHeiUI;
	color: #727272;
	line-height: 18px;
}
.juankuang-right-two-img {
	margin: 5% 4%;
	width: 358px;
	height: 104px;
	cursor: pointer;
}
.juankuang-right-two-img img {
	width: 100%;
	height: 100%;
}
.dongtaidiv1 {
	margin-top: 30px;
	margin-bottom: 30px;
	width: 100%;
	display: flex;
	justify-content: center;
	z-index: 2;
}
.dongtaidiv2 {
	margin-top: 30px;
	margin-bottom: 30px;
	width: 100%;
	display: flex;
	justify-content: center;
	z-index: 2;
}
.hqdangjian{
	margin-top: 30px;
	margin-bottom: 30px;
	width: 100%;
	display: flex;
	justify-content: center;
	z-index: 2;
}
.hqdangjian-img{
	width: 33%;
	height: 140px;
	background: #f2f2f2;
}
.hqdangjian-img + .hqdangjian-img{
	margin-left: 20px;
}
.hqdangjian-img img {
	width: 100%;
	height: 140px;
}
.dongtai {
	width: 1200px;
	display: flex;
}
.dongtai-img {
	width: 33%;
	height: 300px;
	background: #f2f2f2;
}
.dongtai-img + .dongtai-img{
	margin-left: 20px;
}
.dongtai-img img {
	width: 100%;
	height: 260px;
}
.dongtai-img-heard {
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.dongtai-img-footer {
	padding: 0 10px;
	margin-top: 5%;
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: space-between;
}
.dongtai-imgdiv {
	height: 18px;
	font-size: 14px;
	font-family: MicrosoftYaHeiUI;
	color: #333333;
	line-height: 18px;
	width: 235px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.dongtai-imgdiv2{
	height: 18px;
	font-size: 14px;
	font-family: MicrosoftYaHeiUI;
	color: #333333;
	line-height: 18px;
}
.hoqibeijing {
	width: 100%;
	position: relative;
}
.hqclassimgbtm{
	z-index: -1;
	position: absolute;
	bottom: -300px;
	right: 0px;
}
.zuixin {
	display: flex;
	justify-content: space-between;
	background-color: #FFFFFF;
}
.zuixin-left {
	width: 580px;
	height: 381px;
}
.zuixin-left img {
	width: 100%;
	height: 100%;
}
.zuixin-right {
	height: 381px;
	width: 600px;
	margin-left: 20px;
}
.latest-information {
	color: #777777;
	margin-left: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.latest-information span:hover {
	color: #e60011;
}
.latest-information-one {
	display: flex;
	flex-wrap: nowrap;
}
.latest-information img {
	color: #777777;
}
.latest-information + .latest-information {
	border-left: 1px solid #e60011;
	padding-left: 10px;
}
.latest-information span {
	width: 77px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #777777;
	line-height: 20px;
}
.zuixin-right-two {
	margin-top: 20px;
	margin-left: 30px;
}
.zuixin-right-two-frist {
	display: flex;
	justify-content: space-between;
}
.zuixin-right-two-frist ul li {
	margin: 3% 0;
}
.zuixin-right-two-frist ul li span {
	width: 416px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #333333;
	line-height: 20px;
}
.zuixin-right-two-frist ul li img {
	width: 16px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #747171;
	line-height: 20px;
	background-color: #747171;
}
.zuixin-right-two-two {
	cursor: pointer;
	display: flex;
	justify-content: flex-end;
}
.zuixin-right-two-twoaaa {
	cursor: pointer;
	display: flex;
	justify-content: flex-end;
	color: #ffffff;
	margin-top: 40px;
}
.zuixin-right-two-twoaaaz {
	width: 80px;
	height: 20px;
	font-size: 16px;
	font-family: MicrosoftYaHeiUI;
	color: #c11818;
	line-height: 20px;
}

.friend-div {
	margin: 0 auto;
	width: 1200px;
	margin-bottom: 100px;
}
.friend-img-div {
	width: 120px;
	display: flex;
	flex-wrap: wrap;
}
// .friend-img-div +.friend-img-div{
// 	margin-left: 10px;
// }
.friend-img-div img {
	width: 100%;
	height: 100px;
}
.friend-img-div span {
	width: 114px;
	height: 20px;
	font-size: 14px;
	font-family: MicrosoftYaHeiUI;
	color: #333333;
	line-height: 20px;
}
.friend-img {
  margin-bottom: 20px;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
}
</style>
